import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function useFeedbackPointAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const userData = store.state?.userStore?.userData
  const feedbackPoint = ref({})
  const isSubmitting = ref(false)
  const collection = 'feedback_point'

  const create = async (data) => {
    isSubmitting.value = true

    const payload = {
      client_id: oid(userData.client.$oid),
      name: data.name?.value || '',
      physical_location: data.physical_location?.value ? oid(data.physical_location.value) : null,
      location: data.location?.value ? oid(data.location.value) : null,
    }

    try {
      await createItem({ collection, payload })
      showSuccessMessage(i18n.t('message.feedbackPoint_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.feedbackPoint_add_error'))
    } finally {
      router.push({ name: 'organization-feedbackPoint-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    feedbackPoint,
    isSubmitting,
  }
}
